import { ReactNode } from 'react';

import { DataPriorityIcon, IconButton, Tooltip } from '@hcs/design-system';
import { useActiveState } from '@hcs/hooks';

import { MARKET_STATS_FOR_USER_GEO_TYPE } from './marketStateChartsForUser.constants';
import { MarketStateChartsForUserDialog } from './MarketStateChartsForUserDialog';

import styles from './MarketStateChartsForUser.module.css';

interface MarketStateChartsForUserLauncherProps {
  className?: string;
  trigger?: ReactNode;
  showTooltip?: boolean;
  geoType:
    | typeof MARKET_STATS_FOR_USER_GEO_TYPE.ZIP
    | typeof MARKET_STATS_FOR_USER_GEO_TYPE.MSA;
}
const dataHcName = 'cerberus-stats-chart-options-launcher';
export const MarketStateChartsForUserLauncher = ({
  className,
  trigger,
  showTooltip = true,
  geoType,
}: MarketStateChartsForUserLauncherProps) => {
  const { active, handleOpen, handleClose } = useActiveState();
  const renderedTrigger = trigger ? (
    <span
      data-hc-name={dataHcName}
      onClick={handleOpen}
      className={styles.Trigger}
    >
      {trigger}
    </span>
  ) : (
    <IconButton
      dataHcName={dataHcName}
      className={className}
      onClick={handleOpen}
      icon={<DataPriorityIcon size="lg" />}
    />
  );

  return (
    <>
      {showTooltip ? (
        <Tooltip
          dataHcName={`${dataHcName}-tooltip`}
          theme={{
            Trigger: styles.Trigger,
          }}
          trigger={renderedTrigger}
          label="Reorder Charts"
        />
      ) : (
        renderedTrigger
      )}
      <MarketStateChartsForUserDialog
        active={active}
        onClose={handleClose}
        geoType={geoType}
      />
    </>
  );
};
